import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import AddDeviceModal from "./AddDeviceModal";
import { getAdminActions, getDistributorActions } from "../../../config/actions";
import { API_URL, PRODUCT_S3 } from "../../../config";
import { getActiveSiteId } from "../../../utils/site";
import "../DistributorsAdd/DistributorsAdd.css";

const CATEGORY_LABELS = {
  22: "Device",
  24: "Accessory",
};

const stripHtml = (html) => (html ? html.replace(/<[^>]*>/g, "") : "");

const DistributorProducts = () => {
  const navigate = useNavigate();
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem("user_id");
  const [siteId, setSiteId] = useState(localStorage.getItem("site_id"));

  const isAdmin = user_type === "7";
  const sidebarActions = isAdmin
    ? getAdminActions(userId)
    : getDistributorActions(userId);
  const backPath = isAdmin ? "/distributors" : "/mini-cart";

  const [expandedMenu, setExpandedMenu] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showAddModal, setShowAddModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [modules, setModules] = useState([]);

  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [descriptionModal, setDescriptionModal] = useState(null);
  const [modulesModal, setModulesModal] = useState(null);

  useEffect(() => {
    getActiveSiteId().then((resolvedSiteId) => {
      setSiteId(resolvedSiteId);
      fetchProducts(resolvedSiteId);
    });
    fetchModules();

  }, []);

  const fetchProducts = async (resolvedSiteId) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/distributor/product/${resolvedSiteId ?? siteId}`);
      const data = await res.json();
      setProducts(data.status ? data.data || [] : []);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = () => {
    setEditingProduct(null);
    setShowAddModal(true);
  };

  const openEditModal = (product) => {
    setEditingProduct(product);
    setShowAddModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      const res = await fetch(`${API_URL}/distributor/product/${deleteTarget.id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ site_id: siteId }),
      });
      const data = await res.json();
      if (!data.status) {
        throw new Error(data.message || "Failed to delete product");
      }
      setDeleteTarget(null);
      setSuccessMessage("Product deleted successfully!");
      setSuccessModal(true);
      fetchProducts();
    } catch (err) {
      alert(err.message);
    } finally {
      setDeleting(false);
    }
  };


   const fetchModules = async () => {
        // setLoadingModules(true);
        try {
          const res = await fetch(`${API_URL}/get/all/modules`);
          const data = await res.json();
          const allModules = data?.modules || [];
          setModules(allModules);

          console.log("Fetched modules:", allModules);
        } catch (err) {
          console.error("Error fetching modules:", err);
        } finally {
          // setLoadingModules(false);
        }
      };
  

      const showModules = (moduleIds) => {
        console.log("Module IDs:", moduleIds);
        const moduleNames = moduleIds.map((id) => {
          const module = modules.find((mod) => mod.id === parseInt(id));
          return module ? module.name : null;
        }).filter(Boolean); // Filter out null values

        if (moduleNames.length === 0) {
          return <span style={{ color: "#6b7280" }}>—</span>;
        }

        const visibleNames = moduleNames.slice(0, 2);
        const remaining = moduleNames.length - visibleNames.length;

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center" }}>
            {visibleNames.map((name, idx) => (
              <span key={idx} className="count-badge">{name}</span>
            ))}
            {remaining > 0 && (
              <span
                className="count-badge"
                style={{ cursor: "pointer", background: "#e5e7eb", color: "#374151" }}
                onClick={() => setModulesModal(moduleNames)}
              >
                +{remaining} more
              </span>
            )}
          </div>
        );
      };

  return (
    <div className="distributors-add-container">
      <div className="distributors-add-dashboard">
        <QuickActionsSidebar
          actions={sidebarActions}
          expandedMenu={expandedMenu}
          setExpandedMenu={setExpandedMenu}
        />

        <div className="distributors-add-content">
          <div className="add-btn-wrp add-btn-wrp2" style={{alignItems:"center",padding:"10px 20px",gap:"24px"}}>
            <div className="head-listing" style={{ flex: 1, minWidth: 0 }}>
              <button
                onClick={() => navigate(backPath)}
                style={{
                  background: "none",
                  border: "none",
                  color: "rgb(77, 0, 77)",
                  fontWeight: "600",
                  cursor: "pointer",
                  marginBottom: "8px",
                  padding: 0,
                  fontSize: "14px",
                }}
              >
                ← Back
              </button>
              <h3>My Products</h3>
                 <small style={{ fontSize: "14px", color: "#6b7280"}}>
                Create your own product by combining the CapnoGO with specific Modules, videos, webinars, books, and other products.<br />For example, combine the CapnoGO with the Cellphone Module and a webinar for athletes - CapnoGO-athletes. $1,495.00.
              </small>
            </div>
            <button className="btn-primary" style={{ flexShrink: 0 }} onClick={openAddModal}>
              <i className="fas fa-plus"></i>
              Configure your product
            </button>
          </div>

          <div className="distributors-table-section">
            {loading ? (
              <div className="loading-state">
                <div className="loader-spinner"></div>
                <p>Loading products...</p>
              </div>
            ) : products.length === 0 ? (
              <div className="empty-state">
                <i className="fas fa-box-open"></i>
                <p>You haven&apos;t added any products yet.</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table className="distributors-table">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Modules</th>
                      <th>Availability</th>
                      <th>Price</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product) => (
                      <tr key={product.id}>
                        <td>
                          <div style={{
                            width: "48px",
                            height: "48px",
                            borderRadius: "8px",
                            background: "#faf5ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}>
                            {product.product_images ? (
                              <img
                                src={`${PRODUCT_S3}/${product.product_images}`}
                                alt={product.name}
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                onError={(e) => { e.target.style.display = "none"; }}
                              />
                            ) : (
                              <i className="fas fa-image" style={{ color: "#c4b5fd" }}></i>
                            )}
                          </div>
                        </td>
                        <td>{product.name}</td>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => setDescriptionModal(product)}
                        >
                          {stripHtml(product.description).length > 40 ? `${stripHtml(product.description).substring(0, 40)}...` : stripHtml(product.description)}{" "}
                          <span
                            className="count-badge"
                            style={{ background: "#e5e7eb", color: "#374151" }}
                          >
                            see more
                          </span>
                        </td>
                        {/* <td>{product.subtitle || "—"}</td> */}
                        <td>
                          {/* <span className="count-badge">
                            {CATEGORY_LABELS[product.category] || product.category}
                          </span> */}
                          {product.module_id && product.module_id.split(",").length > 0 ? (
                              showModules(product.module_id.split(","))
                          ) : (
                            <span style={{ color: "#6b7280" }}>—</span>
                          )}
                        </td>
                        <td>
                          {product.availability_mode === "inventory" ? (
                            <span
                              className="count-badge"
                              style={{ background: "#e0f2fe", color: "#0369a1" }}
                            >
                              Same as inventory
                            </span>
                          ) : (
                            <span className="count-badge">{product.availability ?? 0}</span>
                          )}
                          {product.availability_date && (
                            <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "4px" }}>
                              Until {product.availability_date}
                            </div>
                          )}
                        </td>
                        <td>${product.price}</td>
                        <td>
                          <div className="dist-action-buttons">
                            <button
                              type="button"
                              className="action-btn view-btn"
                              title="Edit"
                              onClick={() => openEditModal(product)}
                            >
                              <i className="fa fa-pencil-square-o"></i>
                            </button>
                            <button
                              type="button"
                              className="action-btn"
                              title="Delete"
                              onClick={() => setDeleteTarget(product)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      <AddDeviceModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        distributorId={siteId}
        editProduct={editingProduct}
        onSuccess={async ({ imageRemoved } = {}) => {
          const removedId = editingProduct?.id;
          await fetchProducts();
          if (imageRemoved && removedId) {
            // Backend doesn't clear the stored image on removal (frontend-only
            // for now), so the refetch above still returns the old image —
            // override it locally so the list reflects what was actually chosen.
            setProducts((prev) =>
              prev.map((p) => (p.id === removedId ? { ...p, product_images: null } : p))
            );
          }
          setSuccessMessage(editingProduct ? "Product updated successfully!" : "Product added successfully!");
          setSuccessModal(true);
        }}
      />

      {/* Delete Confirmation */}
      <Modal isOpen={!!deleteTarget} toggle={() => setDeleteTarget(null)} centered>
        <ModalBody style={{ textAlign: "center", padding: "32px" }}>
          <i className="fas fa-exclamation-triangle" style={{ fontSize: "36px", color: "#f59e0b", marginBottom: "16px" }}></i>
          <h5>Delete Product</h5>
          <p style={{ color: "#6b7280" }}>
            Are you sure you want to delete <strong>{deleteTarget?.name}</strong>? This cannot be undone.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginTop: "20px" }}>
            <button className="btn-secondary" onClick={() => setDeleteTarget(null)} disabled={deleting}>
              Cancel
            </button>
            <button
              className="btn-primary"
              style={{ background: "#dc2626" }}
              onClick={confirmDelete}
              disabled={deleting}
            >
              {deleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Success Modal */}
      <Modal isOpen={successModal} toggle={() => setSuccessModal(false)} centered>
        <ModalBody className="text-center">
          <div style={{ fontSize: "40px", color: "green" }}>✔</div>
          <h5 className="mt-2">{successMessage}</h5>
          <button
            className="btn btn-success mt-3"
            onClick={() => setSuccessModal(false)}
          >
            OK
          </button>
        </ModalBody>
      </Modal>

      {/* Description Modal */}
      <Modal isOpen={!!descriptionModal} toggle={() => setDescriptionModal(null)} centered>
        <ModalHeader toggle={() => setDescriptionModal(null)} style={{color:"#fff"}}>
          Product Description
        </ModalHeader>
        <ModalBody style={{ padding: "24px" }}>
          {/* <h5>{descriptionModal?.name}</h5> */}
          <p style={{ color: "#374151", whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: descriptionModal?.description || "No description available." }}>
           
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
            <button className="btn-secondary" onClick={() => setDescriptionModal(null)}>
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Modules Modal */}
      <Modal isOpen={!!modulesModal} toggle={() => setModulesModal(null)} centered>
        <ModalHeader toggle={() => setModulesModal(null)} style={{color:"#fff"}}>
          All Modules
        </ModalHeader>
        <ModalBody style={{ padding: "24px" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {modulesModal?.map((name, idx) => (
              <span key={idx} className="count-badge">{name}</span>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
            <button className="btn-secondary" onClick={() => setModulesModal(null)}>
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DistributorProducts;
